import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `text-sm tracking-wide transition-colors duration-200 ${
      isActive ? "text-gray-900 font-semibold" : "text-gray-700 hover:text-gray-900"
    }`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center group">
          <img
            src="/logo-dark.png"
            alt="Mountain Core Construction Group"
            className="h-11 w-auto transition-opacity duration-200 group-hover:opacity-70"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkClass} data-testid={`nav-${n.label.toLowerCase()}`}>
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="bg-gray-900 text-white text-sm font-semibold px-5 py-2.5 rounded-sm hover:bg-gray-700 transition-colors duration-200"
          >
            Request a Consultation
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-gray-900"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={linkClass}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="bg-gray-900 text-white text-sm font-semibold px-5 py-3 rounded-sm text-center hover:bg-gray-700 transition-colors duration-200"
            >
              Request a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
